export default "__VITE_ASSET__a1cee742__"